import React, { useMemo } from 'react';
import { SlidersHorizontal } from 'lucide-react';
import StatusCard from './StatusCard';
import { useDashboardStore } from '../../../stores/dashboard-store';
import { useLanguage } from '../../../contexts/LanguageContext';
import { CheckmarkIcon, FacilityIcon, ForProcurementIcon, OnItsWayIcon } from '../../../components/icons/DashboardIcons';

const AfterShipmentSection: React.FC = () => {
  const { stats } = useDashboardStore();
  const { t } = useLanguage();

  const getStatusValue = (statusKey: string): string => {
    const value = stats?.status_counts?.[statusKey];
    return value !== undefined ? value.toString() : '0';
  };

  const afterShipmentCards = useMemo(() => [
    {
      title: t('dashboard.receivedAtMainWarehouse'),
      value: getStatusValue('received-at-main-warehouse'),
      change: '+8%',
      changeType: 'increase' as const,
      icon: FacilityIcon,
      color: 'cyan',
      navigateTo: '/operation?tab=destination_warehouse&subStatus=in_warehouse'
    },
    {
      title: t('dashboard.shippedToDistributionCenter'),
      value: getStatusValue('shipped-to-distribution-center'),
      change: '+50%',
      changeType: 'increase' as const,
      icon: OnItsWayIcon,
      color: 'purple',
      navigateTo: '/operation?tab=distribution_center&subStatus=inbound'
    },
    {
      title: t('dashboard.receivedAtDistributionCenter'),
      value: getStatusValue('received-at-distribution-center'),
      change: '+50%',
      changeType: 'increase' as const,
      icon: ForProcurementIcon,
      color: 'blue',
      navigateTo: '/operation?tab=distribution_center&subStatus=in_center'
    },
    {
      title: t('dashboard.deliveredToFacility'),
      value: getStatusValue('delivered-to-the-customer'),
      change: '+50%',
      changeType: 'increase' as const,
      icon: CheckmarkIcon,
      color: 'green',
      navigateTo: '/operation?tab=delivered'
    }
  ], [stats, t]);

  return (
    <div>
      <div className="rounded-lg bg-[#F1F1F4] p-3 md:p-4">
        <div className="mb-3 flex items-center justify-between">
          <h2 className="text-[35px] font-medium leading-none text-[#24304F]">{t('dashboard.afterShipment')}</h2>
          <button className="inline-flex items-center gap-1.5 rounded-md bg-[#DFE3EC] px-3 py-1.5 text-[13px] font-medium text-[#5D6680]">
            <SlidersHorizontal size={14} />
            {t('common.month')}
          </button>
        </div>

        <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
          {afterShipmentCards.map((card, index) => (
            <StatusCard key={index} card={card} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default AfterShipmentSection;